import React from "react";
import { PermissionCheck } from "src/helpers/PermissionCheck";
import AdminDashboard from "./admin/AdminDashboard";
import GuardianDashboard from "./guardian/GuardianDashboard";

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard">
      {PermissionCheck("dashboard-all-children") ? (
        <AdminDashboard />
      ) : (
        PermissionCheck("dashboard-my-children") && <GuardianDashboard />
      )}
    </div>
  );
};

export default Dashboard;
